import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import axios from "axios";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

// Main Pages
import Homepage from "./pages/Homepage";
import OpsPage from "./pages/OpsPage";
import AboutPage from "./pages/AboutPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import ContactPage from "./pages/ContactPage";
import PrivacyPage from "./pages/PrivacyPage";

// Agency Sub-pages

// Ops Sub-pages
import AdOperationsPage from "./pages/ops/AdOperationsPage";
import AnalyticsPage from "./pages/ops/AnalyticsPage";
// import CreativeOpsPage from "./pages/ops/CreativeOpsPage"; // Hidden temporarily
import PricingPage from "./pages/ops/PricingPage";

// Cast (MarqiCast) Pages
import CastOverviewPage from "./pages/cast/CastOverviewPage";
import CastCreativePage from "./pages/cast/CastCreativePage";
import CastTargetingPage from "./pages/cast/CastTargetingPage";
import CastMeasurementPage from "./pages/cast/CastMeasurementPage";
import CastInventoryPage from "./pages/cast/CastInventoryPage";
import CastPricingPage from "./pages/cast/CastPricingPage";

// Rank (MarqiRank) Pages
import RankOverviewPage from "./pages/rank/RankOverviewPage";
import RankGeoPage from "./pages/rank/RankGeoPage";
import RankAeoPage from "./pages/rank/RankAeoPage";
import RankChatGptAdsPage from "./pages/rank/RankChatGptAdsPage";
import RankMeasurementPage from "./pages/rank/RankMeasurementPage";
import RankPricingPage from "./pages/rank/RankPricingPage";
import AuditPage from "./pages/AuditPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Homepage />} />
            
            {/* Ops Routes */}
            <Route path="/ops" element={<OpsPage />} />
            <Route path="/ops/ad-operations" element={<AdOperationsPage />} />
            <Route path="/ops/analytics" element={<AnalyticsPage />} />
            {/* <Route path="/ops/creative-ops" element={<CreativeOpsPage />} /> */}
            <Route path="/ops/pricing" element={<PricingPage />} />
            
            {/* Cast (MarqiCast) Routes */}
            <Route path="/cast" element={<CastOverviewPage />} />
            <Route path="/cast/creative" element={<CastCreativePage />} />
            <Route path="/cast/targeting" element={<CastTargetingPage />} />
            <Route path="/cast/measurement" element={<CastMeasurementPage />} />
            <Route path="/cast/inventory" element={<CastInventoryPage />} />
            <Route path="/cast/pricing" element={<CastPricingPage />} />

            {/* Rank (MarqiRank) Routes */}
            <Route path="/rank" element={<RankOverviewPage />} />
            <Route path="/rank/geo" element={<RankGeoPage />} />
            <Route path="/rank/aeo" element={<RankAeoPage />} />
            <Route path="/rank/chatgpt-ads" element={<RankChatGptAdsPage />} />
            <Route path="/rank/measurement" element={<RankMeasurementPage />} />
            <Route path="/rank/pricing" element={<RankPricingPage />} />
            <Route path="/audit" element={<AuditPage />} />

            {/* Other Pages */}
            <Route path="/about" element={<AboutPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;